///
/// EarthBrowser
///
/// Migration: v27 -> v28
/// Enables the hurricane / tropical cyclone dataset by default
///
/// Created by Matt Giger on 9/5/2026
/// Copyright (c) 2026 Geodata Labs
///

interface StateV27 {
	earthbrowser?: {
		visibleDatasets?: string[]
	}
}

/**
 * Migration from version 27 to 28: Add hurricane dataset support
 * - Adds "hurricane" to visibleDatasets so active tropical cyclones show by
 *   default (matching earthquakes/volcanoes/wildfires as default-on hazard layers)
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV27toV28(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV27
	const oldEarthbrowser = s.earthbrowser || {}

	const visibleDatasets = Array.isArray(oldEarthbrowser.visibleDatasets)
		? [...oldEarthbrowser.visibleDatasets]
		: ["cloud", "earthquake", "satellite", "aurora", "volcano", "wildfire"]

	if (!visibleDatasets.includes("hurricane")) {
		visibleDatasets.push("hurricane")
	}

	return {
		...s,
		earthbrowser: {
			...oldEarthbrowser,
			visibleDatasets,
		}
	}
}
